(function(){
  const root  = document.getElementById('product-pdf-root');
  if (!root) return;
  const sheet = document.getElementById('product-pdf-sheet');

  const PREFIX = root.dataset.prefix || 'specifications_';
  const LOGO   = root.dataset.logo  || '';
  const ACCENT = root.dataset.accent|| '#193f71';
  const SHOP   = root.dataset.shop  || '';

  // Embedded JSON from snippet
  const productData  = (()=>{ try { return JSON.parse(document.getElementById('product-pdf-json').textContent); } catch(e){ return null; } })();
  const metafieldsNS = (()=>{ try { return JSON.parse(document.getElementById('product-pdf-metafields-json').textContent) || {}; } catch(e){ return {}; } })();
  const descHtmlRaw  = (()=>{ try { return JSON.parse(document.getElementById('product-pdf-desc-json').textContent) || ''; } catch(e){ return ''; } })();

  const esc = (s)=>String(s||'').replace(/[&<>]/g, c=>({"&":"&amp;","<":"&lt;",">":"&gt;"}[c]));
  const titleCase = (str)=>str.replace(/_/g,' ').replace(/\b\w/g, m=>m.toUpperCase());

  const now = new Date();
  const fmt = (d)=> d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'});

  const currentVariant = () => {
    const vs = productData?.variants || [];
    if (!vs.length) return {};
    const urlParams = new URLSearchParams(window.location.search);
    const vid = urlParams.get('variant');
    let v = vs[0];
    const idInput = document.querySelector('[name="id"]');
    if (vid) v = vs.find(x=>String(x.id)===String(vid)) || v;
    if (idInput && idInput.value) v = vs.find(x=>String(x.id)===String(idInput.value)) || v;
    return v || {};
  };

  // Prefer selected variant image; fall back to product images
  const findHero = ()=>{
    const toAbs = (src)=> src ? (src.startsWith('http') ? src : `https:${src}`) : '';
    const v = currentVariant();
    const images = productData?.images || [];
    if (v?.featured_image?.src) return toAbs(v.featured_image.src);
    if (v?.image?.src) return toAbs(v.image.src);
    if (v?.featured_media?.preview_image?.src) return toAbs(v.featured_media.preview_image.src);
    if (v?.image_id && images.length){
      const byId = images.find(img => String(img.id) === String(v.image_id));
      if (byId?.src) return toAbs(byId.src);
    }
    const fi = productData?.featured_image; const fiSrc = typeof fi === 'string' ? fi : fi?.src;
    if (fiSrc) return toAbs(fiSrc);
    const first = images[0]; const firstSrc = typeof first === 'string' ? first : first?.src;
    return toAbs(firstSrc || '');
  };

  const collectSpecRows = () => {
    const rows = [];
    Object.keys(metafieldsNS || {}).forEach((k)=>{
      if (!k.startsWith(PREFIX)) return;
      const raw = metafieldsNS[k];
      const val = (raw && typeof raw === 'object' && 'value' in raw) ? raw.value : raw;
      if (val !== null && val !== undefined && String(val).trim() !== '') {
        rows.push([k.slice(PREFIX.length), String(val)]);
      }
    });
    rows.sort((a,b)=>a[0].localeCompare(b[0]));
    return rows;
  };

  /**
   * SIMPLE DESCRIPTION EXCERPT
   * - strip images/videos/iframes
   * - remove "Quick Facts" heading and its immediate lists
   * - keep the first block elements (P/UL/OL) in order up to ~700 chars
   */
  const cleanedDesc = (() => {
    let html = descHtmlRaw;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
      const container = doc.body.firstElementChild || doc.body;

      // Remove "Quick Facts" block + immediate lists
      container.querySelectorAll('*').forEach(el=>{
        const t = (el.textContent || '').trim().toLowerCase();
        if (t.startsWith('quick facts') || t.includes('quick facts:')) {
          let sib = el.nextElementSibling; el.remove();
          while (sib && (/^(UL|OL)$/).test(sib.tagName)) { const n=sib.nextElementSibling; sib.remove(); sib=n; }
        }
      });

      // Strip media from description
      container.querySelectorAll('img, picture, source, figure, video, iframe, embed').forEach(el=>el.remove());

      // Remove empty paragraphs
      container.querySelectorAll('p').forEach(p=>{
        if ((p.textContent||'').trim()==='' && !p.querySelector('a, ul, ol, strong, em, span')) p.remove();
      });

      // Keep first blocks (P/UL/OL) until ~700 chars
      const MAX = 700; let total=0; const out=[];
      for (const node of Array.from(container.children)) {
        if (!['P','UL','OL'].includes(node.tagName)) continue;
        const clone = node.cloneNode(true);
        const len = (clone.textContent||'').trim().length;
        if (!len) continue;
        if (total + len > MAX && out.length) break;
        out.push(clone.outerHTML);
        total += len;
      }
      html = out.join('');
    } catch(e){}
    return html;
  })();

  // Delivery block (kept, but WITHOUT the old "Note:" sentence)
  const deliveryBlock = () => {
    const getV = (k)=> {
      const o = metafieldsNS[k];
      return (o && typeof o === 'object' && 'value' in o) ? o.value : o;
    };
    const ht = getV('handling_time');
    const dv = getV('delivery');
    const pu = getV('pickup');
    const bi = getV('bulky_item');

    const p1 = 'All orders are shipped from Australia with fast shipping from trusted couriers & order tracking notifications sent via SMS and email. Complementary shipping insurance included at no extra cost.';
    let p2 = [ht, dv, pu].filter(Boolean).join(' ');
    if (p2 && bi) p2 += ' ' + String(bi);
    if (!p2 && bi) p2 = String(bi);

    return `
      <div class="rc-delivery">
        <h3>Ordering & Delivery</h3>
        <p><strong>Ready to order?</strong> Email <strong>sales@rampchamp.com.au</strong> or call <strong>1300&nbsp;913&nbsp;047</strong>.</p>
        <p>${esc(p1)}</p>
        ${p2 ? `<p>${esc(p2)}</p>` : ''}
      </div>
    `;
  };

  const benefitsBlock = () => `
    <div class="rc-benefits" aria-label="Benefits">
      <div class="rc-benefit"><b>100-Day Free Returns</b> on most items*</div>
      <div class="rc-benefit"><b>Established 2016</b> trusted Australian retailer</div>
      <div class="rc-benefit"><b>ProductReview.com.au</b> Best Hardware Store 2023–2026</div>
      <div class="rc-benefit"><b>40,000+ Happy Customers</b> nationwide</div>
    </div>
  `;

  const buildSheet = () => {
    const v = currentVariant();
    const rows = collectSpecRows();
    const title = productData?.title || '';
    const sku = v?.sku || '';
    const hero = findHero();
    const handle = productData?.handle || '';
    const pdpUrl = (SHOP && handle) ? `${SHOP}/products/${handle}` : '';

    sheet.innerHTML = `
      <div class="rc-header" style="--rc-accent:${ACCENT}">
        <div>
          ${LOGO?`<img class="rc-logo" src="${esc(LOGO)}" alt="Ramp Champ">`:''}
          <h1>${esc(title)}</h1>
          <div class="rc-sub">${sku ? `SKU: ${esc(sku)} • ` : ''}${esc(v?.title||'')}</div>
          <div class="rc-site">www.rampchamp.com.au</div>
        </div>
        ${hero ? `<img class="rc-hero" src="${esc(hero)}" alt="${esc(title)}">` : ''}
      </div>

      <table aria-label="Technical specifications"><tbody>
        ${rows.map(([k,val])=>`<tr><th>${esc(titleCase(k))}</th><td>${esc(val)}</td></tr>`).join('')}
      </tbody></table>

      ${
        cleanedDesc
          ? `<div class="rc-desc">
               ${cleanedDesc}
               ${
                 pdpUrl
                   ? `<div class="rc-readmore">
                        <a href="${esc(pdpUrl)}">Read more ›</a>
                        <small style="display:block;font-size:11px;color:#666;margin-top:2px;word-break:break-all">${esc(pdpUrl)}</small>
                      </div>`
                   : ''
               }
             </div>`
          : ''
      }

      ${deliveryBlock()}

      ${benefitsBlock()}

      <div class="rc-footer">
        <div class="rc-foot-left">Generated ${fmt(now)}</div>
        <div class="rc-foot-right">Tyre Swing Pty Ltd T/as Ramp Champ® | ABN: 84 738 142 818 | ACN: 626 651 278</div>
      </div>
    `;
  };

  const openPrintableWindow = () => {
    buildSheet();
    const v = currentVariant();
    const sku = v?.sku || productData?.variants?.[0]?.sku || productData?.handle || 'spec-sheet';

    const w = window.open('', '_blank');
    if (!w) { alert('Please allow popups to download the spec sheet.'); return; }
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(sku)}</title>
      <link href="https://fonts.googleapis.com/css2?family=Barlow:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page{margin:12mm;}
        body{font-family:Barlow,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#000;background:#fff;}
        .wrap{width:794px;margin:0 auto;box-sizing:border-box;padding:24px;}
        .header{display:grid;grid-template-columns:1fr 240px;gap:16px;border-bottom:2px solid ${ACCENT};padding-bottom:10px;align-items:center}
        .logo{height:46px;width:auto} h1{margin:0;font-size:22px;color:${ACCENT}} .sub{margin-top:4px;font-size:12px;opacity:.9}
        .site{margin-top:4px;font-size:12px;color:${ACCENT};font-weight:700}
        .hero{width:100%;height:auto;border:1px solid #e5e5e5;border-radius:4px;object-fit:contain;background:#fafafa}
        table{width:100%;border-collapse:collapse;margin-top:16px}
        th{width:38%;text-align:left;text-transform:uppercase;font-weight:700;padding:8px 10px;border-bottom:1px solid #d3d3d3}
        td{padding:8px 10px;border-bottom:1px solid #eaeaea}
        .delivery{margin-top:14px;padding:12px;border:2px solid ${ACCENT};border-radius:6px;background:#f4f8ff}
        .delivery h3{margin:0 0 8px 0;font-size:13px;letter-spacing:.02em;text-transform:uppercase;color:${ACCENT}}
        .delivery p{margin:6px 0;font-size:12px;line-height:1.5}
        .desc{margin-top:12px;font-size:12px;line-height:1.45;color:#333}
        .benefits{margin-top:12px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
        .benefit{border:1px dashed #cdd9ee;border-radius:4px;padding:8px 10px;font-size:12px}
        .benefit b{color:${ACCENT}}
        .footer{display:flex;justify-content:space-between;align-items:center;gap:16px;margin-top:18px;padding-top:8px;border-top:1px solid #e2e6ef;color:#555;font-size:12px}
        .foot-left{opacity:.9}
        .foot-right{opacity:.9;text-align:right}
        @media print {.hint{display:none}}
      </style>
    </head><body>
      <div class="wrap">${sheet.innerHTML
        .replaceAll('rc-header','header')
        .replaceAll('rc-logo','logo')
        .replaceAll('rc-sub','sub')
        .replaceAll('rc-site','site')
        .replaceAll('rc-hero','hero')
        .replaceAll('rc-desc','desc')
        .replaceAll('rc-delivery','delivery')
        .replaceAll('rc-benefits','benefits')
        .replaceAll('rc-benefit','benefit')
        .replaceAll('rc-footer','footer')
        .replaceAll('rc-foot-left','foot-left')
        .replaceAll('rc-foot-right','foot-right')}</div>
      <script>setTimeout(function(){window.print();},50);<\/script>
    </body></html>`;
    w.document.open(); w.document.write(html); w.document.close();
  };

  // Delegated click handler
  document.addEventListener('click', (e)=>{
    const trigger = e.target.closest('[data-product-pdf-download]');
    if (!trigger) return;
    e.preventDefault();
    openPrintableWindow();
  }, true);

  // Keep variant info fresh
  document.addEventListener('change', (e)=>{ if(e.target && e.target.name==='id') buildSheet(); });
  let lastUrl = location.href;
  new MutationObserver(()=>{ const u=location.href; if(u!==lastUrl){ lastUrl=u; setTimeout(buildSheet,50); } })
    .observe(document,{subtree:true, childList:true});
})();
